/******/ (() => { // webpackBootstrap
/*!****************************************!*\
  !*** ./src/js/zone3-productcompare.js ***!
  \****************************************/
function initProductCompare(root) {
  var productsGrid = root.querySelector('.zone3__productcompare__products');
  if (!productsGrid) return;
  var addTemplate = productsGrid.querySelector('[data-compare-add-template]');
  var modal = root.querySelector('[data-compare-modal]');
  var productSelectButton = root.querySelectorAll('[data-compare-product-select]');

  // The product cards and the empty "add" slots share the same column order as
  // the rows inside each accordion content grid, so a column index found in the
  // products grid maps directly onto every content grid.
  function getColumns() {
    return Array.from(productsGrid.querySelectorAll(':scope > .zone3__productcompare__product, :scope > .zone3__productcompare__add'));
  }
  function updateModalCount() {
    var countEl = root.querySelector('.zone3__productcompare__modal-content-header-title');
    if (!countEl) return;
    var selected = productsGrid.querySelectorAll(':scope > .zone3__productcompare__product').length;
    countEl.textContent = countEl.textContent.replace(/\d+\s*\/\s*\d+/, function (match) {
      return match.replace(/^\d+/, selected);
    });
  }

  // Duration of the fade/scale transition, kept in sync with the CSS.
  var TRANSITION_MS = 300;

  // Insert a freshly cloned column already faded out, then transition it in on
  // the next frame so the browser registers the starting state first.
  function animateIn(el) {
    el.classList.add('zone3__compare-entering');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        return el.classList.remove('zone3__compare-entering');
      });
    });
  }

  // Remove a column and pack the survivors toward the start: the removed node
  // is deleted (later siblings shift left), a fresh empty slot is appended at
  // the end, and the survivors are slid from their old position into the new
  // one (FLIP) so the reflow animates instead of jumping.
  function flipCompact(container, removedEl, emptyEl, selector) {
    var movers = Array.from(container.querySelectorAll(selector)).filter(function (el) {
      return el !== removedEl;
    });
    var firstRects = movers.map(function (el) {
      return el.getBoundingClientRect();
    });
    removedEl.remove();
    if (emptyEl) container.appendChild(emptyEl);
    movers.forEach(function (el, i) {
      var last = el.getBoundingClientRect();
      var dx = firstRects[i].left - last.left;
      var dy = firstRects[i].top - last.top;
      if (!dx && !dy) return;
      el.style.transition = 'none';
      el.style.transform = "translate(".concat(dx, "px, ").concat(dy, "px)");
      el.getBoundingClientRect(); // flush the inverted position
      requestAnimationFrame(function () {
        el.style.transition = '';
        el.style.transform = '';
      });
    });
    if (emptyEl) animateIn(emptyEl);
  }

  // Toggle a modal "Select" button between its selected / unselected states.
  function setSelectButtonState(button, selected) {
    if (!button) return;
    button.dataset.compareProductSelect = selected ? 'true' : 'false';
    var label = button.querySelector('span') || button;
    if (selected) {
      button.classList.remove('bg-ocean', 'text-mist', 'hover:bg-sky', 'hover:text-ocean');
      button.classList.add('bg-sky', 'text-ocean', 'hover:bg-ocean', 'hover:text-sky');
      label.textContent = 'Selected';
    } else {
      button.classList.remove('bg-sky', 'text-ocean', 'hover:bg-ocean', 'hover:text-sky');
      button.classList.add('bg-ocean', 'text-mist', 'hover:bg-sky', 'hover:text-ocean');
      label.textContent = 'Select';
    }
  }
  function removeProduct(card) {
    // Ignore repeated clicks while a removal is already animating.
    if (card.classList.contains('zone3__compare-leaving')) return;
    var columnIndex = getColumns().indexOf(card);
    if (columnIndex === -1) return;

    // Keep the matching modal "Select" button in sync.
    var productId = card.dataset.productId;
    if (productId) {
      setSelectButtonState(root.querySelector("[data-compare-product-select][data-product-id=\"".concat(productId, "\"]")), false);
    }

    // Collect the matching column in each accordion content grid up front.
    var contentTargets = [];
    root.querySelectorAll('.zone3__productcompare__content').forEach(function (grid) {
      var infos = grid.querySelectorAll(':scope > .zone3__productcompare__content-info');
      var target = infos[columnIndex];
      if (target) contentTargets.push({
        grid: grid,
        target: target
      });
    });

    // Fade/scale everything in this column out.
    card.classList.add('zone3__compare-leaving');
    contentTargets.forEach(function (_ref) {
      var target = _ref.target;
      return target.classList.add('zone3__compare-leaving');
    });

    // Once faded out, drop the column, compact the survivors toward the start
    // and append a fresh empty slot at the end.
    setTimeout(function () {
      var addSlot = addTemplate && addTemplate.content.firstElementChild ? addTemplate.content.firstElementChild.cloneNode(true) : null;
      flipCompact(productsGrid, card, addSlot, ':scope > .zone3__productcompare__product, :scope > .zone3__productcompare__add');
      contentTargets.forEach(function (_ref2) {
        var grid = _ref2.grid,
          target = _ref2.target;
        var emptyTemplate = grid.querySelector('[data-compare-empty-template]');
        var emptyCol = emptyTemplate && emptyTemplate.content.firstElementChild ? emptyTemplate.content.firstElementChild.cloneNode(true) : null;
        flipCompact(grid, target, emptyCol, ':scope > .zone3__productcompare__content-info');
      });
      updateModalCount();
    }, TRANSITION_MS);
  }
  function modalOpen() {
    if (!modal) return;
    // Drop `hidden` first so the element is laid out, then trigger the opacity
    // transition on the next frame.
    modal.classList.remove('hidden');
    requestAnimationFrame(function () {
      modal.classList.remove('opacity-0', 'pointer-events-none');
      modal.classList.add('opacity-100', 'pointer-events-auto', 'flex');
    });
  }
  function modalClose() {
    if (!modal) return;
    modal.classList.remove('opacity-100', 'pointer-events-auto', 'flex');
    modal.classList.add('opacity-0', 'pointer-events-none');
    var _onEnd = function onEnd() {
      modal.classList.add('hidden');
      modal.removeEventListener('transitionend', _onEnd);
    };
    modal.addEventListener('transitionend', _onEnd);
  }

  // The header and its panel are linked by a matching data-attribute value
  // (e.g. data-compare-accordion="ratings" / data-compare-accordion-content="ratings").
  function getAccordionPanel(accordion) {
    var key = accordion.getAttribute('data-compare-accordion');
    return root.querySelector("[data-compare-accordion-content=\"".concat(key, "\"]"));
  }
  function openAccordion(accordion, panel) {
    accordion.classList.remove('is-collapsed');
    accordion.setAttribute('aria-expanded', 'true');
    // Animate from the current (0) height up to the content height, then hand
    // control back to `height: auto` so the panel can scroll horizontally and
    // resize when products are added/removed.
    panel.style.overflow = 'hidden';
    panel.style.height = "".concat(panel.scrollHeight, "px");
    var _onEnd2 = function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.style.height = '';
      panel.style.overflow = '';
      panel.removeEventListener('transitionend', _onEnd2);
    };
    panel.addEventListener('transitionend', _onEnd2);
  }
  function closeAccordion(accordion, panel) {
    accordion.classList.add('is-collapsed');
    accordion.setAttribute('aria-expanded', 'false');
    panel.style.overflow = 'hidden';
    panel.style.height = "".concat(panel.scrollHeight, "px");
    panel.getBoundingClientRect(); // flush the fixed height before collapsing
    requestAnimationFrame(function () {
      panel.style.height = '0px';
    });
  }
  function toggleAccordion(accordion) {
    var panel = getAccordionPanel(accordion);
    if (!panel) return;
    if (accordion.classList.contains('is-collapsed')) {
      openAccordion(accordion, panel);
    } else {
      closeAccordion(accordion, panel);
    }
  }

  // Single delegated click handler so it also covers the add slots that get
  // cloned in when a product is removed.
  root.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-compare-product-remove]');
    if (removeBtn) {
      var card = removeBtn.closest('.zone3__productcompare__product');
      if (card) removeProduct(card);
      return;
    }
    var accordion = event.target.closest('[data-compare-accordion]');
    if (accordion) {
      toggleAccordion(accordion);
      return;
    }
    if (event.target.closest('[data-compare-add-slot], [data-compare-add]')) {
      modalOpen();
      return;
    }

    // Close when clicking the dimmed backdrop.
    if (event.target.closest('.zone3__productcompare__modal-background')) {
      modalClose();
    }
    if (event.target.closest('[data-compare-modal-close]')) {
      modalClose();
      return;
    }
  });

  // Clone the product's pre-rendered card + accordion columns (carried in the
  // modal as <template>s) into the first empty slot of the compare table.
  function addProductFromModal(modalProduct) {
    var emptySlot = productsGrid.querySelector(':scope > .zone3__productcompare__add');
    if (!emptySlot) return false;
    var columnIndex = getColumns().indexOf(emptySlot);
    if (columnIndex === -1) return false;
    var cardTpl = modalProduct.querySelector('[data-compare-card-template]');
    if (cardTpl && cardTpl.content.firstElementChild) {
      var card = cardTpl.content.firstElementChild.cloneNode(true);
      emptySlot.replaceWith(card);
      animateIn(card);
    } else {
      return false;
    }

    // Content grids are rendered in a fixed order: Ratings, then Key Features.
    var contentTpls = [modalProduct.querySelector('[data-compare-ratings-template]'), modalProduct.querySelector('[data-compare-features-template]')];
    root.querySelectorAll('.zone3__productcompare__content').forEach(function (grid, gridIndex) {
      var infos = grid.querySelectorAll(':scope > .zone3__productcompare__content-info');
      var target = infos[columnIndex];
      var tpl = contentTpls[gridIndex];
      if (!target || !tpl || !tpl.content.firstElementChild) return;
      var col = tpl.content.firstElementChild.cloneNode(true);
      target.replaceWith(col);
      animateIn(col);
    });
    updateModalCount();
    return true;
  }
  function removeProductById(id) {
    var card = productsGrid.querySelector(":scope > .zone3__productcompare__product[data-product-id=\"".concat(id, "\"]"));
    if (card) removeProduct(card);
  }
  function handleSelectClick(button) {
    var modalProduct = button.closest('[data-compare-modal-product]');
    var isSelected = button.dataset.compareProductSelect === 'true';
    if (isSelected) {
      removeProductById(button.dataset.productId);
      setSelectButtonState(button, false);
    } else if (modalProduct && addProductFromModal(modalProduct)) {
      setSelectButtonState(button, true);
    }
  }
  productSelectButton.forEach(function (button) {
    var label = button.querySelector('span') || button;
    button.addEventListener('click', function (event) {
      event.preventDefault();
      handleSelectClick(button);
    });
    button.addEventListener('mouseenter', function () {
      if (button.dataset.compareProductSelect === 'true') label.textContent = 'Deselect';
    });
    button.addEventListener('mouseleave', function () {
      if (button.dataset.compareProductSelect === 'true') label.textContent = 'Selected';
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') modalClose();
  });
}
function init() {
  document.querySelectorAll('product-compare').forEach(initProductCompare);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
/******/ })()
;
//# sourceMappingURL=zone3-productcompare.js.map